import React from 'react';
import { clsx } from 'clsx';

interface TableCellProps extends React.HTMLAttributes<HTMLTableCellElement> {
  children: React.ReactNode;
  colSpan?: number;
}

export function TableCell({ children, className, colSpan, ...props }: TableCellProps) {
  return (
    <td 
      className={clsx(
        "px-6 py-4 whitespace-nowrap text-sm text-gray-900", 
        className
      )} 
      colSpan={colSpan}
      {...props}
    >
      {children}
    </td>
  );
} 